// extracted by mini-css-extract-plugin
export var root = "header-module--root--2Pllp";
export var rootSpacer = "header-module--rootSpacer--sc55f";
export var wrapper = "header-module--wrapper--182n5";
export var branding = "header-module--branding--1PjA2";
export var toggleNavButton = "header-module--toggleNavButton--34Tf4";
export var nav = "header-module--nav--106zH";
export var showNav = "header-module--showNav--CuuOZ";
export var navSearch = "header-module--navSearch--2UfSa";
export var overlaycontent = "header-module--overlaycontent--Lyynt";
export var closebtn = "header-module--closebtn--16kCA";
export var showNavSearch = "header-module--showNavSearch--3Sr_v";
export var searchInput = "header-module--searchInput--30Q_s";
export var searchButton = "header-module--searchButton--2Ld1L";